import BaseListPage from "../../../../base/BaseListPage";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import TotalSalesDayPresenter from "./TotalSalesDayPresenter.js";
import Export from "../../../../components/Export/index.js";
import printChart from "../../../../PrintChart.js";
import { Progress } from "nq-component";
import DefaultState from "../../../sales-and-transactions/components/DefaultState.js";
import Select from "react-select";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import InitialPrompt from "../../../../components/InitialPrompt/index.js";
import HighchartsSalesReport from "./components/HighchartsSalesReport.js";
import ProgressLoader from "../../../../components/ProgressLoader/index.js";

class TotalSalesDayPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TotalSalesDayPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );

    this.state = {
      objects: [],
      isShow: false,
      selectedDate: new Date().toISOString().split("T")[0],
      selectedStoreCode: "",
      totalSalesPerHour: [],
      totalTransactionsPerHour: [],
      storess: "",
      store: [],
      notFound: false,
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", "")
    );
    return [...new Set(storeCodes)];
  }

  filterTransactions(transactions) {
    const selectedDate = new Date(this.state.selectedDate);
    selectedDate.setHours(5, 0, 0, 0);

    const endDate = new Date(selectedDate);
    endDate.setDate(endDate.getDate() + 1);
    endDate.setHours(4, 59, 59, 999);

    return transactions
      .filter((status) => status.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.tran_date);

        const selectedDateMatch =
          transactionDate >= selectedDate && transactionDate <= endDate;
        const storeCodeMatch = this.state.selectedStoreCode
          ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
            this.state.selectedStoreCode
          : true;

        return selectedDateMatch && storeCodeMatch;
      });
  }

  handleDateChange(event) {
    const selectedDate = event.target.value;
    const formattedDate = this.formatDate(selectedDate);
    this.setState({ selectedDate: event.target.value, isShow: true });
    this.presenter.onChangeDate(formattedDate);
  }

  formatDate(dateString) {
    const date = new Date(dateString);

    // Start date (same day at 05:00:00.000)
    const startTime = new Date(date);
    startTime.setHours(5, 0, 0, 0);
    const formattedStartTime = this.formatDateToCustom(startTime);

    // End date (next day at 04:59:00.000)
    const endTime = new Date(date);
    endTime.setDate(endTime.getDate() + 1); // Move to the next day
    endTime.setHours(4, 59, 0, 0);
    const formattedEndTime = this.formatDateToCustom(endTime);

    return {
      tran_date: {
        $gte: formattedStartTime,
        $lte: formattedEndTime,
      },
    };
  }

  formatDateToCustom(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  calculateAverageSales(transactions) {
    const averageSales = new Array(24).fill(0);
    const hourCounts = new Array(24).fill(0);
    const totalTransactionsPerHour = new Array(24).fill(0);

    transactions.forEach((transaction) => {
      const date = new Date(transaction.tran_date);
      const hour = date.getHours();

      const index = (hour < 5 ? hour + 24 : hour) - 5;

      const grossSales = parseFloat(transaction.total);

      const sales = grossSales - parseFloat(transaction.total_tax);

      averageSales[index] += sales;
      hourCounts[index]++;
      totalTransactionsPerHour[index]++;
    });

    return { averageSales, totalTransactionsPerHour };
  }

  getChartData() {
    const filteredTransactions = this.filterTransactions(this.state.objects);

    const fill = filteredTransactions.filter((item) => item.tran_date);

    const { averageSales, totalTransactionsPerHour } =
      this.calculateAverageSales(filteredTransactions);
    if (
      JSON.stringify(this.state.totalSalesPerHour) !==
      JSON.stringify(averageSales)
    ) {
      this.setState({ totalSalesPerHour: averageSales });
      this.setState({ totalTransactionsPerHour });
    }
    const labels = Array.from({ length: 24 }, (_, i) => {
      const hour = (5 + i) % 24;
      return `${hour}:00`;
    });
    return {
      labels: labels, // 0 to 23, labeled as hours
      datasets: [
        {
          label: "Total Sales",
          data: averageSales,
          backgroundColor: "#006096",
          borderColor: "#006096",
          borderWidth: 1,
        },
      ],
    };
  }

  getChartOptions() {
    const filteredTransactions = this.filterTransactions(this.state.objects);
    const { averageSales, totalTransactionsPerHour } =
      this.calculateAverageSales(filteredTransactions);

    const labels = Array.from({ length: 24 }, (_, i) => {
      const hour = (5 + i) % 24;
      return `${hour}:00`;
    });

    const formattedSales = averageSales.map((sales) =>
      parseFloat(sales.toFixed(2))
    );

    return {
      chart: {
        type: "column",
      },
      title: {
        text: "Total Sales vs. Hour of Today",
      },
      xAxis: {
        categories: labels,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: "Total Sales (PHP)",
        },
      },
      tooltip: {
        formatter: function () {
          const totalTransactions =
            totalTransactionsPerHour[this.point.index] || 0;
          return `
            <b>${this.x}</b><br/>
            Total Sales: ₱${this.y.toFixed(2)}<br/>
            Total Transactions: ${totalTransactions}
          `;
        },
      },
      series: [
        {
          name: "Total Sales",
          data: formattedSales,
          color: "#006096",
        },
      ],
    };
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  getCollectionName() {
    return "transactions";
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  getCollectionName() {
    return "transactions";
  }

  convertToCSV(objArray) {
    const array =
      typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
    let str =
      `${Object.keys(array[0])
        .map((value) => `"${value}"`)
        .join(",")}` + "\r\n";
    for (let i = 0; i < array.length; i++) {
      let line = "";
      for (let index in array[i]) {
        if (line !== "") line += ",";
        line += `"${array[i][index]}"`;
      }
      str += line + "\r\n";
    }
    return str;
  }

  exportToCSV = () => {
    const {
      selectedBrand,
      selectedStoreCode,
      selectedDate,
      totalSalesPerHour,
      storess,
    } = this.state;

    const csvData = totalSalesPerHour.map((sales, index) => {
      const hour = (5 + index) % 24; // Adjust according to your chart's starting hour
      return {
        brand: "Angels Pizza",
        store: storess || "All Stores",
        date: selectedDate,
        time: `${hour}:00`,
        averageSales: sales.toFixed(2),
      };
    });

    const csvString = this.convertToCSV(csvData);
    const a = document.createElement("a");
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    a.href = url;
    a.download = `total-sales-time.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const { objects, storess, selectedDate } = this.state;
    const chartData = this.getChartData();
    const chartOptions = this.getChartOptions();
    const printId = "chart-container3";
    const formatSales = (sales) => {
      return sales.toLocaleString("en-US", {
        style: "currency",
        currency: "PHP",
      });
    };

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <h2 className="fw-bold text-capitalize mt-4">
            <span style={{ color: "darkcolor" }}>Total</span>
            <span style={{ color: "#83c14a" }}> Sales</span>
            <span style={{ color: "darkcolor" }}> vs. </span>
            <span style={{ color: "#83c14a" }}>Hour of Today</span>
          </h2>
          <Export
            exportCsv={() => this.exportToCSV()}
            exportPdf={() => printChart(printId)}
          />
        </div>
        <div className="row mb-2">
          <div className="col-sm-2">
            <input
              className="form-control"
              type="date"
              // value={this.state.selectedDate}
              onChange={this.handleDateChange}
            />
          </div>
          <div className="col-sm-4">
            <Select
              options={[
                { value: "AllStore", label: "All Store" },
                ...this.state.store.map((code) => ({
                  value: code.name,
                  label: code.name,
                })),
              ]}
              onChange={(selectedOption) =>
                this.onChangeStore(selectedOption?.value)
              }
              isDisabled={!this.state.isShow}
            />
          </div>
        </div>
        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <HighchartsSalesReport
            chartOptions={chartOptions}
            chartData={chartData}
            formatSales={formatSales}
            storess={storess}
            selectedDate={selectedDate}
            chartRef={this.chartRef3}
            containerId="chart-container3"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess &&
          this.state?.selectedDate &&
          !this.state.notFound ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default TotalSalesDayPage;
